<template>
  <div class="payment-methods">
    <div class="title">
      <div class="title-l">
        Express Checkout Options
      </div>
      <div class="title-r">
        <img
          class="title-r__icon"
          src="@/assets/carts/secure.svg"
        >
        Secure Checkout
      </div>
    </div>
    <div class="methods">
      <!-- 骨架屏 -->
      <template v-if="loading">
        <div class="methods-item _skeleton" />
        <div class="methods-item _skeleton" />
      </template>

      <template v-else>
        <div
          @click="changePayment(item)"
          v-for="item in payments"
          :key="item.value"
          :class="{
            '_active': paymentType === item.value,
            '_disabled': item.disabled
          }"
          class="methods-item"
        >
          <div class="methods-item-l">
            <img
              class="icon"
              :src="item.icon"
              alt=""
            >
            {{ item.name }}
          </div>
          <div class="methods-item-r">
            <div class="inner" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import paypalIcon from '@/assets/H5/orderFilling/paypal.png'
import bankIcon from '@/assets/H5/orderFilling/bank.png'
import { useOrder } from '../../hooks/useOrder'
import { useCart } from '../../hooks/useCart'

const { loading } = useCart()
const { paymentType, totalAmountAfterDiscount } = useOrder()

const payments = computed(() => [
  {
    name: 'Pay with PayPal',
    icon: paypalIcon,
    disabled: totalAmountAfterDiscount.value > 500,
    value: 0
  },
  {
    name: 'Pay with Bank Transfer',
    icon: bankIcon,
    value: 1
  }
])

const changePayment = (item) => {
  if (item.disabled) return
  paymentType.value = item.value
}

</script>

<style lang='less' scoped>
.payment-methods {
  margin-top: 24px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-l {
      color: #232323;
      font-size: 20px;
      font-family: mon-700;
      line-height: 28px;
    }
    .title-r {
      display: flex;
      align-items: center;
      gap: 2px;
      color: #1153D6;
      font-size: 12px;
      line-height: 16px;
      font-family: mon-500;

      &__icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  .methods {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    .methods-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 8px;
      height: 64px;
      padding: 0 24px;
      border: 1px solid #EBF1F5;
      cursor: pointer;
      &:hover {
        border: 1px solid #232323;
      }
      &._skeleton {
        background-color: #f8f8f8;
        animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
      }
      &._active {
        outline: 2px solid #232323;
        border: none;
        .methods-item-r {
          display: flex;
          align-items: center;
          justify-content: center;
          border-color: #232323;
          background-color: #232323;
          .inner {
            opacity: 1;
          }
        }
      }
      &._disabled {
        filter: grayscale(1) opacity(.5);
        cursor: not-allowed;
      }
      .methods-item-l {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        .icon {
          height: 32px;
          background-color: #F8F8F8;
        }
      }
      .methods-item-r {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid #EBF1F5;
        .inner {
          background-color: white;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          opacity: 0;
        }
      }
    }
  }
}

@keyframes skeleton {
  0% {
    background-color: #EBEBEB;
  }
  25% {
    background-color: #F8F8F8;
  }
  80% {
    background-color: #EBEBEB;
  }
  100% {
    background-color: #EBEBEB;
  }
}
</style>
